// src/hooks/useGroupedJobs.js
import {useMemo} from 'react';

export const useGroupedJobs = (stackedJobs) => {

  return useMemo(() => {
    const projectsMap = {};
    const ungrouped = [];
    
    if (!Array.isArray(stackedJobs)) {
      return { projects: [], ungroupedJobs: [] };
    }

    // Group jobs by projectId
    stackedJobs.forEach((job) => {
      if (!job) return;
      const projectId = job.projectId;
      if (projectId && projectId !== null && projectId !== undefined && projectId !== "") {
        if (!projectsMap[projectId]) {
          projectsMap[projectId] = {
            projectId: job.projectId,
            projectName: job.projectName || "Unnamed Project",
            projectDescription: job.projectDescription,
            workspaceId: job.workspaceId,
            workspaceName: job.workspaceName,
            jobs: [],
          };
        }
        projectsMap[projectId].jobs.push(job);
      } else {
        ungrouped.push(job);
      }
    });

    // Convert map to array
    let projectsArray = Object.values(projectsMap);
    
    // Sort projects by the most recent note timestamp among their jobs
    projectsArray.sort((a, b) => {
      const aLatest = Math.max(
        ...a.jobs.map(job => new Date(job.latestTimeStamp || 0).getTime())
      );
      const bLatest = Math.max(
        ...b.jobs.map(job => new Date(job.latestTimeStamp || 0).getTime())
      );
      return bLatest - aLatest;
    });
    
    return { projects: projectsArray, ungroupedJobs: ungrouped };
  }, [stackedJobs]);
};